<template>
  <div class="curr-month-overview">
    <div class="body-title flex-center">《{{ monthReportTitle }}》</div>
    <div class="flex-align-center" style="margin-bottom: 20px">
      <img
        src="@/assets/imgs/school/monthRecord/dashboard.png"
        alt=""
        style="width: 24px; height: 20px; margin-right: 15px"
      />
      <div class="record-title">本月概览</div>
    </div>
    <!--数据统计-->
    <div class="overview-list flex-between">
      <div class="overview-list-item">
        <div class="card-title">
          <div>全校平均情绪指数</div>
          <img src="@/assets/imgs/school/monthRecord/line.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <CountAnimation
            :end-val="Number(dataSource.schoolAvgEmotionValue)"
            :attr="{ decimals: 2 }"
            class="count-bold"
            style="color: #1062fe"
          />
          <div v-html="dataSource.schoolHistoryAvgEmotionValueStr" style="margin: 5px 0"></div>
          <div>
            <span>{{ dataSource.gradeEmotionTop }}最高 {{ dataSource.gradeEmotionTopValue }}</span>
            ｜
            <span>{{ dataSource.gradeEmotionLow }}最低 {{ dataSource.gradeEmotionLowValue }}</span>
          </div>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>情绪提醒总数</div>
          <img src="@/assets/imgs/school/monthRecord/remind.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <div>
            <CountAnimation :end-val="Number(dataSource.remindStudentCount)" class="count-bold" />
            人
          </div>
          <div style="margin: 5px 0">
            <span>{{ dataSource.twoRemindStudentCount }} 人两次提醒</span>
            ｜
            <span>{{ dataSource.threeRemindStudentCount }} 人三次及以上</span>
          </div>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>低活跃度学生</div>
          <img src="@/assets/imgs/school/monthRecord/figure.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <div>
            <CountAnimation
              :end-val="dataSource.moodContinuedLowModelStudentCount"
              class="count-bold"
            />
            名
          </div>
          <div style="margin: 5px 0">
            <span style="color: #ff4646">
              {{ faceCollectInfo.faceNotGatherCount }} 名未采集数据
            </span>
            ｜
            <span>需重点核实</span>
          </div>
        </div>
      </div>
      <div class="overview-list-item">
        <div class="card-title">
          <div>提醒处理率</div>
          <img src="@/assets/imgs/school/monthRecord/love.png" alt="" class="item-icon" />
        </div>
        <div style="transform: translateY(-15px)">
          <div>
            <CountAnimation :end-val="Number(dataSource.remindDealRate)" :attr="{ decimals: 2 }" class="count-bold" />
            %
          </div>
          <div style="margin: 5px 0">
            <span>未处理 {{ dataSource.remindNotDealRate }}%</span>
            <!--｜-->
            <!--<span>家校互动1次</span>-->
          </div>
        </div>
      </div>
    </div>
    <!--文本卡片-->
    <div class="text-area">
      <div class="text-header flex-between">
        <div class="flex-align-center">
          <img
            src="@/assets/imgs/school/monthRecord/panel.png"
            style="width: 24px; height: 24px; margin-right: 5px"
          />
          <span class="title-1" style="color: #fff">本月总结</span>
          <span class="title-3" style="color: #fff">｜本月工作中，我们共同呵护着每一位学生的心理状态，也见证了各班级在心理关怀上的积极努力。</span>
        </div>
        <img
          src="@/assets/imgs/school/monthRecord/screenshot.png"
          style="width: 208px; height: 100%"
        />
      </div>
      <div class="text-content">
        <!--一、情绪总览-->
        <div class="summary-section flex-align-center">
          <img src="@/assets/imgs/school/monthRecord/emotion_overview.png" alt="" class="section-icon" />
          <div class="section-body">
            <div class="section-title">一、情绪总览</div>
            <div class="section-item">
              全校本月平均情绪指数<span class="hl">{{ emotionIndex }}</span
              >，相比于上月情绪指数整体<span class="hl">{{ emotionChangeRate }}</span
              >，各个班中情绪指数最高的班级为<span class="hl">{{ top3ClassesText }}</span>
            </div>
            <!-- <div class="section-item">
              全校本月关键词：<span class="hl">焦虑</span>
            </div> -->
            <div class="section-item">
              显开心的日期<span class="hl">{{ happiestDate }}</span>，最开心的时间段
              <span class="hl">{{ happiestTimePeriod }}</span>
            </div>
          </div>
        </div>
        <!--二、关怀详情-->
        <div class="summary-section flex-align-center">
          <img src="@/assets/imgs/school/monthRecord/care_details.png" alt="" class="section-icon" />
          <div class="section-body">
            <div class="section-title">二、关怀详情</div>
            <div class="section-item">
              全校本月共提醒 <span class="hl">{{ remindTotal }}</span> 人，其中
              <span class="hl"
                >{{ twoRemindCount }} 人两次提醒，{{ threeRemindCount }}
                人三次以上提醒，重点关注学生提醒 {{ keyCareRemindCount }} 人</span
              >，较于上月提醒名单趋势<span class="hl">{{ remindTrend }}</span>
            </div>
            <div class="section-item">
              本月<span class="hl">整体关怀率 {{ careRate }}</span>
              <span v-if="gradeCareRateText">，<span class="hl">{{ gradeCareRateText }}</span></span>
            </div>
            <div class="section-item">
              本月影响学生情绪的因素有：<span
                v-for="(item, index) in reasonList"
                :key="`${item.name}-${index}`"
              >
                <span class="hl">{{ item.name }}（{{ item.ratio }}）</span>
                <span v-if="index !== reasonList.length - 1">、</span>
              </span>
            </div>
          </div>
        </div>
        <!--三、教师管理（左文列表 + 右数据列表）-->
        <div class="summary-section flex-align-center">
          <img src="@/assets/imgs/school/monthRecord/teacher_management.png" alt="" class="section-icon" />
          <div class="section-body">
            <div class="section-title">三、教师管理</div>
            <div class="teacher-cols">
              <div>
                <div class="section-item">
                  本月班主任登录<span class="hl"
                    >使用最多的前三名分别是{{ mostUsedClassNamesText }}</span
                  >
                </div>
                <div class="section-item">
                  本月<span class="hl"
                    >班主任关怀率最高的前三名是{{ highestCareRateClassNamesText }}</span
                  >
                </div>
                <div class="section-item">
                  本月<span class="hl">没有提醒的班级是{{ notRemindedClassNamesText }}</span>
                </div>
              </div>
              <div>
                <div class="section-item">
                  <span class="hl"
                    >本月班主任家访 {{ teacherHomeVisitCount }}次，心理老师家访
                    {{ psychologistHomeVisitCount }}次</span
                  >
                </div>
                <div class="section-item">
                  <span class="hl"
                    >本月班主任主动关怀{{ headTeacherActiveCareCount }}次，心理老师主动辅导
                    {{ psychologistActiveCounselingCount }}次</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="text-item">
          本月工作中，我们共同呵护着每一位学生的心理状态，也见证了各班级在心理关怀上的积极努力。
        </div>
        <div class="text-item">
          <span class="vary-text">
            本月整体情绪指数为{{ dataSource.schoolAvgEmotionValue }}，相比上月略有波动，其中{{
              dataSource.gradeEmotionTop
            }}表现稳定且较为积极，{{ dataSource.gradeEmotionLow }}则稍显低落。
          </span>
          每个班级都有属于自己的节奏与情绪气候，请多关注那些情绪信号较低的班级和同学，用我们的温暖支持与他们同行，一起传递阳光与力量。
        </div>
        <div class="text-item">
          <span class="vary-text">
            本月共计发出
            {{ dataSource.remindStudentCount }}
            人次提醒，绝大多数班级都及时响应并跟进了学生的状态{{
              dataSource.dealFullMarksTopClassNameStr
            }}。
          </span>
          同时，我们也看到有少数班级尚未登录或处理提醒名单，这或许是因为日常工作繁忙，期待班主任老师们能抽空跟进，共同为学生的心理健康保驾护航。
        </div>
        <div class="text-item">
          <span class="vary-text">
            值得一提的是，
            {{ recordCarefullyText }}在处理学生心理关怀方面积累了宝贵经验，值得我们一起学习与推广。
          </span>
          每一个细致的关注、每一次耐心的倾听，都在孩子们心中种下安全的种子。
        </div>
        <div class="text-item">
          同时我们也注意到，部分学生活跃度较低，可能由于客观原因（如居家、转学等）或近期行为习惯的变化。无论是哪一种情况，都值得我们轻声询问、主动关怀。年级组长和班主任老师们的持续跟进尤为重要，也请心理老师协助核实情况，让我们一同为每个孩子营造安心、温暖的成长环境。
        </div>
        <div class="text-item">
          💗感谢每一位老师在育人路上的付出与坚持，让我们继续携手，用理解与陪伴，点亮每一颗心灵的微光。
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import {
  queryExcellentDealClassTopThree,
  getEmotionOverview,
  getCareDetails,
  getTeacherDetail,
} from '@api/monthReport'
import { formatYearMonth, getYearMonthByNum } from '@/utils/date'

// 空值兜底展示
const fmtVal = (val) => (val === undefined || val === null || val === '' ? '-' : val)

// 班级名数组 → 顿号连接文本，无数据显示 '-'
const joinText = (list) => {
  const arr = (Array.isArray(list) ? list : []).filter((item) => item !== '' && item !== null && item !== undefined)
  return arr.length ? arr.join('、') : '-'
}

export default {
  name: 'CurrMonthOverview',
  components: {
    CountAnimation,
  },
  props: {
    schoolName: {
      type: String,
      default: '',
    },
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    dataSource: {
      type: Object,
      default: () => ({}),
    },
    // 人脸采集信息源
    faceCollectInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      recordCarefullyText: '',
      dateRangeObj: {},
      // 情绪总览
      emotionOverview: {},
      // 关怀详情
      careDetails: {},
      // 教师管理
      teacherDetail: {},
    }
  },
  watch: {
    dateRange(dateObj) {
      this.dateRangeObj = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.queryExcellentDealClassTopThree()
      this.queryEmotionOverview()
      this.queryCareDetails()
      this.queryTeacherDetail()
    },
  },
  computed: {
    monthReportTitle() {
      const baseTitle = `${formatYearMonth(
        this.dateRangeObj?.startTime || getYearMonthByNum(-1),
        'YYYY年MM月'
      )}情绪报告`

      return this.schoolName ? `${this.schoolName}-${baseTitle}` : baseTitle
    },
    // 一、情绪总览
    emotionIndex() {
      return fmtVal(this.emotionOverview.schoolEmotionIndex)
    },
    emotionChangeRate() {
      return fmtVal(this.emotionOverview.emotionChangeRate)
    },
    top3ClassesText() {
      const list = this.emotionOverview.top3Classes || []
      return list.length ? list.join('、') : '-'
    },
    happiestDate() {
      return fmtVal(this.emotionOverview.happiestDate)
    },
    happiestTimePeriod() {
      return fmtVal(this.emotionOverview.happiestTimePeriod)
    },
    // 二、关怀详情
    remindTotal() {
      return fmtVal(this.careDetails.remindTotalCount)
    },
    twoRemindCount() {
      return fmtVal(this.careDetails.twoRemindCount)
    },
    threeRemindCount() {
      return fmtVal(this.careDetails.threeRemindCount)
    },
    keyCareRemindCount() {
      return fmtVal(this.careDetails.keyCareRemindCount)
    },
    remindTrend() {
      return fmtVal(this.careDetails.remindTrend)
    },
    careRate() {
      return fmtVal(this.careDetails.careRate)
    },
    gradeCareRateText() {
      const list = this.careDetails.gradeCareRateList || []
      return list.map((item) => `${item.gradeName}关怀率${item.careRate}`).join('、')
    },
    // 影响因素：只取单一原因，排除空值、"1,6" 这类组合值以及"无异常情况"，最多 4 个
    reasonList() {
      const list = this.careDetails.reasonRatioList || []
      return list
        .filter(
          (item) =>
            item.reasonName !== '' &&
            String(item.reasonName) !== '0' &&
            !String(item.reasonName).includes(',')
        )
        .map((item) => ({
          name: item.reasonName,
          ratio: item.ratio,
        }))
    },
    // 三、教师管理
    // 班主任访问次数最多的前三名班级
    mostUsedClassNamesText() {
      return joinText(this.teacherDetail.mostUsedClassNames)
    },
    // 班主任关怀率最高的前三名班级
    highestCareRateClassNamesText() {
      return joinText(this.teacherDetail.highestCareRateClassNames)
    },
    // 未被提醒的班级
    notRemindedClassNamesText() {
      return joinText(this.teacherDetail.notRemindedClassNames)
    },
    // 班主任家访次数
    teacherHomeVisitCount() {
      return fmtVal(this.teacherDetail.teacherHomeVisitCount)
    },
    // 心理老师家访次数
    psychologistHomeVisitCount() {
      return fmtVal(this.teacherDetail.psychologistHomeVisitCount)
    },
    // 班主任主动关怀次数
    headTeacherActiveCareCount() {
      return fmtVal(this.teacherDetail.headTeacherActiveCareCount)
    },
    // 心理老师主动辅导次数
    psychologistActiveCounselingCount() {
      return fmtVal(this.teacherDetail.psychologistActiveCounselingCount)
    },
  },
  methods: {
    async queryExcellentDealClassTopThree() {
      const { success, result } = await queryExcellentDealClassTopThree(this.dateRangeObj)
      if (success) {
        this.recordCarefullyText = result.map((item) => item.className).join('、')
      }
    },
    // 情绪总览
    async queryEmotionOverview() {
      const { success, result } = await getEmotionOverview(this.dateRangeObj)
      if (success) {
        this.emotionOverview = result || {}
      }
    },
    // 关怀详情
    async queryCareDetails() {
      const { success, result } = await getCareDetails(this.dateRangeObj)
      if (success) {
        this.careDetails = result || {}
      }
    },
    // 教师管理
    async queryTeacherDetail() {
      const { success, result } = await getTeacherDetail(this.dateRangeObj)
      if (success) {
        this.teacherDetail = result || {}
      }
    },
  },
}
</script>
<style scoped lang="less">
.curr-month-overview {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .body-title {
    margin-bottom: 10px;
    font-size: 26px;
    font-weight: 600;
    color: #333;
  }
  .overview-list {
    .overview-list-item {
      box-sizing: border-box;
      width: 24%;
      height: 150px;
      padding: 16px;
      border: 1px solid #f3f4f6;
      border-radius: 10px;
      .card-title {
        display: flex;
        justify-content: space-between;
      }
      .count-bold {
        font-size: 24px;
        font-weight: bold;
      }
      .item-icon {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
    }
  }
  .text-area {
    overflow: hidden;
    margin-top: 20px;
    border-radius: 11.75px;
    background-color: #fafcff;
    .text-header {
      box-sizing: border-box;
      height: 55px;
      padding-left: 20px;
      background: linear-gradient(130.74deg, rgba(23, 144, 255, 1) 0%, rgba(23, 144, 255, 0) 100%);
    }
    .text-content {
      padding: 20px;
      font-weight: 500;
      color: #383838;
      line-height: 23.49px;
      // 本月总结分区（情绪总览/关怀详情/教师管理）
      .summary-section {
        margin-bottom: 30px;
        background-color:#fff;
        border-radius:20px;
        padding:20px;
        &:last-child {
          margin-bottom: 0;
        }
        .section-icon {
          flex-shrink: 0;
          width: 80px;
          height: 80px;
          margin-right: 40px;
        }
        .section-body {
          flex: 1;
          .section-title {
            margin-bottom: 12px;
            font-size:16px;
            font-weight: bold;
            color: #262626;
          }
          .section-item {
            margin-bottom: 8px;
            &:before {
              content: '';
              display: inline-block;
              width: 5px;
              height: 5px;
              margin-right: 10px;
              border-radius: 50%;
              background-color: #383838;
              vertical-align: middle;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
          .teacher-cols {
            display: flex;
            > div {
              flex: 1;
            }
          }
          .hl {
            color: #3ba1f5;
          }
        }
      }
      .text-item {
        margin-bottom: 30px;
        // 在前面画一个圆圈，圆圈和文本居中对齐，第二、三、四圆圈为蓝色
        &:before {
          content: '';
          display: inline-block;
          width: 5px;
          height: 5px;
          margin-right: 10px;
          border-radius: 50%;
          background-color: #383838;
          vertical-align: middle;
        }
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          &:before {
            background-color: #3ba1f5;
          }
        }
        //最后一个元素去除下边距
        &:last-child {
          margin-bottom: 0;
        }
        .vary-text {
          color: #3ba1f5;
        }
      }
    }
  }
}
</style>
